import _asyncToGenerator from "/var/jenkins_home/workspace/tingle.b462fce8-c3fd-4157-817f-5a1715b99180/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "/var/jenkins_home/workspace/tingle.b462fce8-c3fd-4157-817f-5a1715b99180/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/var/jenkins_home/workspace/tingle.b462fce8-c3fd-4157-817f-5a1715b99180/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins_home/workspace/tingle.b462fce8-c3fd-4157-817f-5a1715b99180/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/var/jenkins_home/workspace/tingle.b462fce8-c3fd-4157-817f-5a1715b99180/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/var/jenkins_home/workspace/tingle.b462fce8-c3fd-4157-817f-5a1715b99180/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins_home/workspace/tingle.b462fce8-c3fd-4157-817f-5a1715b99180/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _regeneratorRuntime from "/var/jenkins_home/workspace/tingle.b462fce8-c3fd-4157-817f-5a1715b99180/workspace/node_modules/next/node_modules/@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

// ignore-string-externalization
import '../legacy/styles/spBootstrap.css';
import React from 'react';
import getCookies from 'next-cookies';
import '../polyfill';
import 'lazysizes';
import 'lazysizes/plugins/attrchange/ls.attrchange';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import App from 'next/app';
import { AppTheme } from '@mrkt/features/encore-theme/creator';
import Head from 'next/head';
import withRedux from 'next-redux-wrapper';
import configureStore from '../legacy/shared/store';
import LegacyPage from '../legacy/root/LegacyPage';
import { Page as NewPage } from '../features/Layout';
import { isPreview } from '../features/utils';
import { QualarooSurvey } from '@mrkt/features/QualarooSurvey';
import { useCurrentUser } from '../@mrkt/useCurrentUser';
import { withHooks } from '@mrkt/features/withHooks';
import { compose } from 'redux';
import { GTM } from '@mrkt/features/gtm';
import { startAxeOverlay } from '@mrkt/features/start-axe-overlay';
import { track } from '@spotify-internal/track-js';
import { RemoteConfig } from '@mrkt/features/RemoteConfig';
import { appWithI18n } from '@mrkt/features/i18n/appWithI18n';
import { LanguageHead } from '@mrkt/features/i18n/components/LanguageHead';
import { MrktAppLanguageLogger } from '@mrkt/features/i18n/components/MrktAppLanguageLogger';
import { appWithCssTransform } from '@mrkt/features/css/appWithCssTransform';
import { info } from '@mrkt/features/i18n/locales/info'; // Customize NextJS app wrapper per page
// Here we dynamically import a different layout wrapper depending on
// if this is a "legacy" url, or a new "frodor" URL.
// Also uses withRedux() for legacy URLs to make sure the app store is
// passed to the client (see next-redux-wrapper library)
// @ts-ignore

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var Site = /*#__PURE__*/function (_App) {
  _inherits(Site, _App);

  var _super = _createSuper(Site);

  function Site() {
    _classCallCheck(this, Site);

    return _super.apply(this, arguments);
  }

  _createClass(Site, [{
    key: "render",
    value: function render() {
      var _currentUser$partnerI;

      var _ref = this.props,
          Component = _ref.Component,
          pageProps = _ref.pageProps,
          store = _ref.store,
          initialProps = _ref.initialProps,
          router = _ref.router,
          currentUser = _ref.currentUser;
      var userId = currentUser === null || currentUser === void 0 ? void 0 : (_currentUser$partnerI = currentUser.partnerIds) === null || _currentUser$partnerI === void 0 ? void 0 : _currentUser$partnerI.qualaroo;
      var additionalProperties = currentUser ? {
        name: currentUser.name,
        username: currentUser.username,
        loginEmail: currentUser.loginEmail,
        // qualaroo doesn't display boolean values on the ui, unsure if they are queryable
        hasAccess: "".concat(currentUser.hasAccess)
      } : undefined;
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(LanguageHead, {
          base: "https://artists.spotify.com"
        }), /*#__PURE__*/_jsx(Head, {
          children: /*#__PURE__*/_jsx("meta", {
            name: "viewport",
            content: "width=device-width, initial-scale=1"
          })
        }), /*#__PURE__*/_jsx(RemoteConfig, {
          children: /*#__PURE__*/_jsxs(AppTheme, _objectSpread(_objectSpread({}, this.props), {}, {
            children: [isLegacyPath(router.pathname) ? /*#__PURE__*/_jsx(LegacyPage, {
              store: store,
              props: _objectSpread(_objectSpread({}, pageProps), initialProps),
              Component: Component
            }) : /*#__PURE__*/_jsx(NewPage // @ts-ignore
            , {
              props: _objectSpread(_objectSpread({}, pageProps), initialProps),
              Component: Component,
              router: router
            }), /*#__PURE__*/_jsx(QualarooSurvey, {
              identity: userId,
              additionalProperties: additionalProperties
            })]
          }))
        }), true && /*#__PURE__*/_jsx(GTM, {
          trackingId: "GTM-NP2G964"
        }), /*#__PURE__*/_jsx(MrktAppLanguageLogger, {})]
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      startAxeOverlay();
      track({
        market: 'not_set',
        oneTrust: // ignore cookie banner in synthetic tests for now
        !navigator.webdriver && // cookie is only set on *.spotify.com
        window.location.host.endsWith('.spotify.com')
      });
    }
  }], [{
    key: "getInitialProps",
    value: function () {
      var _getInitialProps = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2) {
        var _Component$getInitial;

        var Component, ctx, cookies, preview, activeSession, smartlingLanguage, locale, props;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                Component = _ref2.Component, ctx = _ref2.ctx;
                cookies = getCookies(ctx);
                preview = isPreview(ctx);
                activeSession = 'sp_dc' in cookies;
                smartlingLanguage = getLanguage(ctx.locale);
                locale = ctx.locale;
                _context.next = 8;
                return (_Component$getInitial = Component.getInitialProps) === null || _Component$getInitial === void 0 ? void 0 : _Component$getInitial.call(Component, _objectSpread(_objectSpread({}, ctx), {}, {
                  preview: preview,
                  smartlingLanguage: smartlingLanguage,
                  locale: locale,
                  activeSession: activeSession
                }));

              case 8:
                _context.t0 = _context.sent;

                if (_context.t0) {
                  _context.next = 11;
                  break;
                }

                _context.t0 = {};

              case 11:
                props = _context.t0;
                return _context.abrupt("return", {
                  initialProps: _objectSpread(_objectSpread({}, props), {}, {
                    preview: preview,
                    activeSession: activeSession
                  })
                });

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function getInitialProps(_x) {
        return _getInitialProps.apply(this, arguments);
      }

      return getInitialProps;
    }()
  }]);

  return Site;
}(App);
export function isLegacyPath(path) {
  var segments = path.split('/');
  var root = segments[1];
  var isBlogHub = root === 'blog' && segments.length === 2;
  return ['facebook', 'videos', 'contact'].includes(root) || isBlogHub;
}
export function getLanguage(locale) {
  var _info$locale$contentf, _info$locale;

  return (_info$locale$contentf = (_info$locale = info[locale]) === null || _info$locale === void 0 ? void 0 : _info$locale.contentful) !== null && _info$locale$contentf !== void 0 ? _info$locale$contentf : info.en.contentful;
}
var withCurrentUser = withHooks(function () {
  return {
    currentUser: useCurrentUser()
  };
});
export default compose(appWithCssTransform, appWithI18n, withCurrentUser, withRedux(configureStore))(Site);